// A tiny indirection so non-React code (axios, media fetcher) can get the
// current Clerk session token without importing Clerk hooks.
let tokenGetter = async () => null

export function setAuthTokenGetter(fn) {
  tokenGetter = typeof fn === 'function' ? fn : async () => null
}

export async function getAuthToken() {
  try {
    return await tokenGetter()
  } catch {
    return null
  }
}
